import { Utils, Trans } from "Helpers";
import { ReduxHOC } from 'HOC';
import { withRouter } from 'react-router-dom/cjs/react-router-dom';

function TeamOfTheWeek(props) {
  	let MasterData =  props.teamWiseWeek;

    const goToTW =()=>{
        props.history.push(`/team-of-theweek?dt_week=${props.dt_week}`);
    }

  return (
    <div className="team-container">
      <h1 className="team-title"><Trans>Team of the Week</Trans></h1>

      <div className="players-section">
        {/* Header */}
        <div className="header-row">
          <div className="header-cell"><Trans>Pos</Trans></div>
          <div className="header-cell"><Trans>Player</Trans></div>
          <div className="header-cell"><Trans>Team</Trans></div>
          <div className="header-points"><Trans>Pts</Trans></div>
        </div>

        {/* Players */}
        {Object.values(MasterData.tow).map((player, index) => (
          <div key={index} className="player-row">
            <div className="position-cell">{player.position}</div>
            <div className="player-cell">
              <img src={Utils.playerJersyUrl(player.jersey)} width={20} alt="" />
              <span className="player-name-team">{player.full_name}</span>
            </div>
            <div className="team-cell">{player.team_abbreviation}</div>
            <div className="points-cell">{player.fantasy_score}</div>
          </div>
        ))}
      </div>

      {/* Total Points */}
      <div className="total-section" onClick={()=>goToTW()}>
        <span className="total-text"><Trans>Total Points</Trans> {MasterData.pow?.total_score}</span>
        <i className="icon-back"></i>
      </div>
    </div>
  )
}
export default withRouter(ReduxHOC(TeamOfTheWeek));
